import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { SSO } from '../sso/sso.constants';
import { EncryptionService } from '../sso/encryption.service';
import { RealmType } from '../shared/enums/realm-type.enum';
import { SharedConstants } from '../shared/constants/shared.constants';

declare let userLoginStatus: any;
declare let loggedInMemberId: any;
declare let canShowSplashInitally: any;
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor() { }
    cookieService: CookieService = new CookieService(document);
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // Get the auth token from the service.
        /*
        * The verbose way:
        // Clone the request and replace the original headers with
        // cloned headers, updated with the authorization.
        const authReq = req.clone({
          headers: req.headers.set('Authorization', authToken)
        });
        */
        // Clone the request and set the new header in one step.
        const authReq = this.requestOptions(req);
        // send cloned request with header to the next handler.
        return next.handle(authReq);
    }

    private requestOptions(req: HttpRequest<any>) {
        if (req.url.startsWith(environment.apiUrl) && !req.url.startsWith(environment.apiUrl + '/payment/')) {
            const uuid = SSO.getnonce();
            let inlcudeAuthorizationToken = true;
            let token = '';
            let ssoToken = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.ACCESS_TOKEN) : this.cookieService.get(SSO.ACCESS_TOKEN);
            if (!this.cookieService.get(SSO.MEMBER_ID) || ssoToken === null || ssoToken === undefined || ssoToken === '') {
                const userInfo = localStorage.getItem('appcoporate.userInfo');
                if ((userInfo !== null && userInfo !== undefined && userInfo !== '') || userLoginStatus === true) {
                    if (userInfo !== null && userInfo !== undefined && userInfo !== '') {
                        localStorage.removeItem('appcoporate.userInfo');
                    }
                    userLoginStatus = false;
                    window.location.reload();
                }
            }

            const userId = this.cookieService.get(SSO.MEMBER_ID);
            const eventPage = SharedConstants.EVENT_PAGES.find((page: string) => {
                return window.location.href.toLowerCase().indexOf(page.toLowerCase()) > -1;
            });
            if (userId && (canShowSplashInitally !== true) && !eventPage) {
                if (loggedInMemberId !== userId) {
                    loggedInMemberId = userId;
                    window.location.reload();
                }
            }
            let realmType = RealmType.TITAN_EXTERNAL;
            if (!ssoToken) {
                ssoToken = localStorage.getItem('appcoporate.guestToken');
                realmType = RealmType.TITAN_GUEST;
            }
            if (typeof ssoToken !== 'undefined' && ssoToken) {
                const header = 'Bearer ' + ssoToken + '&&' + realmType;
                if (environment.enableAuthorization) {
                    inlcudeAuthorizationToken = true;
                    token = this.getAuthorizationHeader(header, uuid);
                }
                if (environment.enableAuthentication) {
                    inlcudeAuthorizationToken = false;
                    token = header;
                }
            }
            // let tokenName = inlcudeAuthorizationToken ? "Authorization" : "Authentication";
            // const authReq = req.clone({ setHeaders: { tokenName : token, UUID: uuid } });
            // return authReq;
            if (inlcudeAuthorizationToken) {
                const authReq = req.clone({ setHeaders: { Authorization: token, UUID: uuid, 'Content-Type':'application/json' } });
                return authReq;
            } else {
                const authReq = req.clone({ setHeaders: { Authentication: token, UUID: uuid, 'Content-Type':'application/json' } });
                return authReq;
            }
        }
        return req;
    }

    private getAuthorizationHeader(token: string, uuid: string): string {
        const data = uuid + '||' + token;
        return EncryptionService.encryptText(data);
    }
}